<template>
  <div class="absolute-fill d-flex justify-center align-center">
    <div ref="btn" v-bind:style="{ transform: `scale(${blob.btn.scale || 1})` }">
      <!-- Note that we use mousedown.capture to make sure the 'edit' event triggers before the blob becomes selected (since we ignore it on the first attempt) -->
      <v-btn
        v-blur
        style="pointer-events: auto;"
        x-large rounded height="56" min-width="56" dark target="_blank"
        :elevation="isTransparent ? 0 : 6"
        :color="blob.btn.color || 'primary'"
        v-bind="(isInteractive && blob.btn.url) ? { href: blob.btn.url } : {}"
        @click="isInteractive && $emit('click')"
      >
        <span v-if="blob.btn.text" v-bind:class="{ 'mr-1': blob.btn.url }" v-html="blob.btn.text" />
        <v-icon v-if="!blob.btn.form && !isTransparent" v-html="mdiOpenInNew" />
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mdiOpenInNew } from '@mdi/js';

const TRANSPARENT_RE = /(^rgba\([^,]+,[^,]+,[^,]+,\s*0+\s*\)$)|(^#[\da-f]{3}0$)|(^#[\da-f]{6}00$)/i;

export default {
  name: 'btn-blob',

  props: [ 'isOwner', 'mode', 'blob' ],

  created() {
    Object.assign(this, { mdiOpenInNew });
  },

  computed: {
    isInteractive() {
      return !(this.isOwner && [ 'design', 'purchase', 'edit' ].includes(this.mode));
    },

    isTransparent() {
      return TRANSPARENT_RE.test(this.blob.btn.color || '');
    }
  },

  methods: {
    async adjust() {
      // We do this asynchronously to avoid interfering with updates made elsewhere
      await this.$nextTick();
      const w = this.$refs.btn.clientWidth * (this.blob.btn.scale || 1);
      if (w != this.blob.w)
        this.blob.w = w;
      const h = this.$refs.btn.clientHeight * (this.blob.btn.scale || 1);
      if (h != this.blob.h)
        this.blob.h = h;
    }
  },

  watch: {
    blob: {
      immediate: true,
      async handler() {
        await this.$nextTick();
        this.adjust();
        this.$emit('loaded');
      }
    },

    'blob.btn.scale'() {
      this.adjust();
    },

    'blob.btn.text'() {
      this.adjust();
    }
  }
}
</script>
